import {
  toTypedRxJsonSchema,
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxJsonSchema,
  RxDocument,
  RxCollection,
} from 'rxdb'
import IThumbnailResponse from 'src/system/content/models/IThumbnailResponse'

export const folderSchemaLiteral = {
  title: 'Folder Schema',
  description: 'Describes a folder, containing media & parent folder',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    parents: {
      type: 'array',
      ref: 'folders',
      items: {
        type: 'string',
      },
    },
    name: {
      type: ['string', 'null'],
    },
    description: {
      type: ['string', 'null'],
    },
    thumbnail: {
      type: ['string', 'null'],
    },
    resources: {
      type: 'array',
      ref: 'resources',
      items: {
        type: 'string',
      },
    },
    createdAt: {
      type: ['string', 'null'],
    },
    updatedAt: {
      type: ['string', 'null'],
    },
  },
  required: ['id'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(folderSchemaLiteral)

export type FolderDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const folderSchema: RxJsonSchema<FolderDocType> = schemaTyped

export type FolderDocMethods = {
  isFolder: () => boolean
  isResource: () => boolean
  getThumbnail: () => IThumbnailResponse
}

export const folderDocMethods = {
  isFolder: () => true,
  isResource: () => false,
  getThumbnail(): IThumbnailResponse {
    return {
      maximize: !!this.thumbnail,
      url: this.thumbnail || '/icons/folder.svg',
    }
  },
}

export type FolderDocument = RxDocument<FolderDocType, FolderDocMethods>

export type FolderCollectionMethods = {
  test: () => void
}

export type FolderCollection = RxCollection<FolderDocType, FolderDocMethods, FolderCollectionMethods>
